
































import Vue from 'vue';
import contact, { Contact } from '@/modules/contact/contact';

interface DataType {
  contacts: Contact[] | null;
  emptyText: string;
}

export default Vue.extend({
  name: 'exhibitor-contact-list',
  data(): DataType {
    return {
      contacts: null,
      emptyText: `お問い合わせはありません。
      ブースを設定してバイヤーにアピールしましょう。`,
    };
  },
  methods: {
    async fetchContact() {
      try {
        this.$loading(true);
        const res = await contact.loadsByExhibitor(this.$auth.cid);
        this.contacts = res;
      } catch (err: any) {
        this.$fatal(err);
      } finally {
        this.$loading(false);
      }
    },
    toTopPage() {
      window.location.href = '/ssr/';
    },
    onClickListItem(id: string) {
      this.$router.push({ name: 'exhibitor-contact-chat', params: { id } });
    },
  },
  async mounted() {
    await this.fetchContact();
  },
});
